import React from "react";

const ScreenLoader = () => {
    return (
        <div className="flex justifyCenter alignCenter w-100 h-100">
            <div className="flex column justifyCenter alignCenter w-100 h-100">
                <div className="screen_loader" />
                <p style={{ color: "#058464", fontSize: 24 }}>پروسیسنگ جاری ہے</p>
            </div>
        </div>
    )
}

export default ScreenLoader;